const actions = {
    PAYMENT_METHOD_CREATE_REQUEST: 'PAYMENT_METHOD_CREATE_REQUEST',
    PAYMENT_METHOD_CREATE_SUCCESS: 'PAYMENT_METHOD_CREATE_SUCCESS',
    PAYMENT_METHOD_CREATE_ERROR: 'PAYMENT_METHOD_CREATE_ERROR',

    // PAYMENT_METHOD_IMPORT_REQUEST: 'PAYMENT_METHOD_IMPORT_REQUEST',
    // PAYMENT_METHOD_IMPORT_SUCCESS: 'PAYMENT_METHOD_IMPORT_SUCCESS',
    // PAYMENT_METHOD_IMPORT_ERROR: 'PAYMENT_METHOD_IMPORT_ERROR',

    PAYMENT_METHOD_READ_REQUEST: 'PAYMENT_METHOD_READ_REQUEST',
    PAYMENT_METHOD_READ_SUCCESS: 'PAYMENT_METHOD_READ_SUCCESS',
    PAYMENT_METHOD_READ_ERROR: 'PAYMENT_METHOD_READ_ERROR',

    PAYMENT_METHOD_READ_ALL_REQUEST: 'PAYMENT_METHOD_READ_ALL_REQUEST',
    PAYMENT_METHOD_READ_ALL_SUCCESS: 'PAYMENT_METHOD_READ_ALL_SUCCESS',
    PAYMENT_METHOD_READ_ALL_ERROR: 'PAYMENT_METHOD_READ_ALL_ERROR',

    PAYMENT_METHOD_UPDATE_REQUEST: 'PAYMENT_METHOD_UPDATE_REQUEST',
    PAYMENT_METHOD_UPDATE_SUCCESS: 'PAYMENT_METHOD_UPDATE_SUCCESS',
    PAYMENT_METHOD_UPDATE_ERROR: 'PAYMENT_METHOD_UPDATE_ERROR',

    PAYMENT_METHOD_ARCHIVE_REQUEST: 'PAYMENT_METHOD_ARCHIVE_REQUEST',
    PAYMENT_METHOD_ARCHIVE_SUCCESS: 'PAYMENT_METHOD_ARCHIVE_SUCCESS',
    PAYMENT_METHOD_ARCHIVE_ERROR: 'PAYMENT_METHOD_ARCHIVE_ERROR',

    PAYMENT_METHOD_DELETE_REQUEST: 'PAYMENT_METHOD_DELETE_REQUEST',
    PAYMENT_METHOD_DELETE_SUCCESS: 'PAYMENT_METHOD_DELETE_SUCCESS',
    PAYMENT_METHOD_DELETE_ERROR: 'PAYMENT_METHOD_DELETE_ERROR',

    PAYMENT_METHOD_RESET_STATE: 'PAYMENT_METHOD_RESET_STATE',
    PAYMENT_METHOD_CHANGE: 'PAYMENT_METHOD_CHANGE',

    PAYMENT_METHOD_TOGGLE_DRAWER: 'PAYMENT_METHOD_TOGGLE_DRAWER',

    createPaymentMethod: request => ({
        type: actions.PAYMENT_METHOD_CREATE_REQUEST,
        request,
    }),
    readPaymentMethod: id => ({
        type: actions.PAYMENT_METHOD_READ_REQUEST,
        id,
    }),
    readAllPaymentMethod: request => ({
        type: actions.PAYMENT_METHOD_READ_ALL_REQUEST,
        request,
    }),
    updatePaymentMethod: (id, request) => ({
        type: actions.PAYMENT_METHOD_UPDATE_REQUEST,
        id,
        request,
    }),
    archivePaymentMethod: (id, request) => ({
        type: actions.PAYMENT_METHOD_ARCHIVE_REQUEST,
        id,
        request,
    }),
    deletePaymentMethod: id => ({
        type: actions.PAYMENT_METHOD_DELETE_REQUEST,
        id,
    }),
    resetPaymentMethod: id => ({
        type: actions.PAYMENT_METHOD_RESET_STATE,
        id,
    }),

    changePaymentMethod: (request, reset = false) => ({
        type: actions.PAYMENT_METHOD_CHANGE,
        request,
        reset,
    }),

    togglePaymentMethodDrawer: (visible, mode) => ({
        type: actions.PAYMENT_METHOD_TOGGLE_DRAWER,
        visible,
        mode, // 'create', 'update'
    }),
};
export default actions;
